import { ACTION_TYPE, GETTER_TYPE, MUTATION_TYPE } from './types'
import dictsApi from '@/api/dicts'

export default {
  state: {
    organizations: [],
    roles: null,
    olympics: [],
    link: null,
    expertExampleLink: null
  },
  mutations: {
    [MUTATION_TYPE.setOrganizations]: (state, organizations) => {
      state.organizations = organizations
    },
    [MUTATION_TYPE.setRoles]: (state, roles) => {
      state.roles = roles
    },
    [MUTATION_TYPE.setOlympics]: (state, olympics) => {
      state.olympics = olympics
    },
    [MUTATION_TYPE.setLink]: (state, link) => {
      state.link = link
    },
    [MUTATION_TYPE.setExpertExampleLink]: (state, link) => {
      state.expertExampleLink = link
    },
    [MUTATION_TYPE.fixClassNames]: (state) => {
      const classes = state.organizations.filter((p) => (p.type === 'ГП-класс'))
      const titles = {}
      classes.forEach((c) => {
        const old = titles[c.title]
        if (old !== undefined) {
          if (old !== -1) {
            old.title = `${old.title} (${old.org})`
            titles[c.title] = -1
          }
          c.title = `${c.title} (${c.org})`
        } else {
          titles[c.title] = c
        }
      })
    }
  },
  actions: {
    [ACTION_TYPE.fetchOrganizations]: ({ commit }) => new Promise((resolve) => {
      dictsApi.getOrganizationDict()
        .then((response) => {
          commit('setOrganizations', response.data)
          commit('fixClassNames')
          resolve()
        })
        .catch(() => {
          commit('setOrganizations', [])
          resolve()
        })
    }),
    [ACTION_TYPE.fetchOlympics]: ({ commit }) => new Promise((resolve) => {
      dictsApi.getOlympicsDict()
        .then((response) => {
          commit('setOlympics', response.data)
          resolve()
        })
        .catch(() => {
          commit('setOlympics', [])
          resolve()
        })
    }),
    [ACTION_TYPE.fetchRoles]: async ({ commit }) => new Promise((resolve, reject) => {
      dictsApi.getRoles().then(({ data }) => {
        commit(MUTATION_TYPE.setRoles, data)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    }),
    [ACTION_TYPE.fetchLink]: async ({ commit }) => new Promise((resolve, reject) => {
      dictsApi.getLink().then((response) => {
        commit(MUTATION_TYPE.setLink, response.data)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    }),
    [ACTION_TYPE.fetchExpertExampleLink]: ({ commit }) => new Promise((resolve, reject) => {
      dictsApi.getExpertExampleFile().then((response) => {
        commit(MUTATION_TYPE.setExpertExampleLink, response.data)
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getters: {
    [GETTER_TYPE.getOrganizations]: (state) => state.organizations,
    [GETTER_TYPE.getClasses]: (state) => state.organizations.filter((p) => p.type === 'ГП-класс'),
    [GETTER_TYPE.getRoles]: (state) => state.roles,
    [GETTER_TYPE.getOlympics]: (state) => state.olympics,
    [GETTER_TYPE.getLink]: (state) => state.link,
    [GETTER_TYPE.getExpertExampleLink]: (state) => state.expertExampleLink
  }
}
